module.exports = __webpack_public_path__ + "img/experiment.9cafec53.jpg";